<div data-testid="marketplace-order-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "third_party.orders.title" | translate }}
  </h2>

  <app-search-form
    data-testid="marketplace-order-search-form"
    [searchFormat]="searchFormat"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (secondaryButtonClick)="onColumnConfigClick($event)"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Ready to ship + Print waybill: select orders via checkbox, then batch actions -->
  <div class="mb-2 flex items-center gap-3 flex-table-header">
    <app-button
      [testId]="'marketplace-order-ready-to-ship-btn'"
      type="info"
      [outlined]="true"
      [label]="'order.marketplace.ready_to_ship.button' | translate"
      icon="local_shipping"
      (emitOnClick)="onReadyToShipBatch()"
    ></app-button>
    <app-button
      [testId]="'marketplace-order-print-waybill-btn'"
      type="info"
      [outlined]="true"
      [label]="'order.marketplace.print_waybill.button' | translate"
      icon="receipt_long"
      (emitOnClick)="onPrintWaybillBatch()"
    ></app-button>
  </div>

  <!-- Advanced Data Table with checkbox column, select all, and actions -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="marketplace-order-table"
      #advancedTable
      [dataSource]="orders()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      [hasCheckColumn]="true"
      [hasHeaderCheckbox]="true"
      [selection]="selectedOrders()"
      (selectionChange)="onSelectionChange($event)"
      [showInternalColumnConfigButton]="false"
    >
    <ng-template #customTemplate let-value let-column="column">
      @if (column.template === "operationTimeTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-center">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column.template === "currencyTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-end">
          {{ formatCurrency(value) }}
        </span>
      } @else if (column.template === "statusTemplate") {
        <span class="flex items-center justify-center">
          <p-tag
            data-testid="marketplace-order-status-tag"
            [value]="getStatusDisplayText(column.prop, value) | translate"
            [severity]="getStatusSeverity(column.prop, value)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(column.prop, value)"
            [pTooltip]="getStatusTooltip(column.prop, value) | translate"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </span>
      } @else if (column.prop === "isGift") {
        <p-tag
          data-testid="marketplace-order-gift-status-tag"
          [value]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          [severity]="value ? 'success' : 'danger'"
          styleClass="status-tag"
          [pTooltip]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      } @else {
        {{ value }}
      }
    </ng-template>
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center flex-nowrap items-center">
        @if (canRead()) {
          <app-button
            [testId]="'marketplace-order-action-view-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
        @if (isPacked(rowData)) {
          <app-button
            [testId]="'marketplace-order-action-ready-to-ship-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-enable"
            [label]="'order.marketplace.ready_to_ship.action' | translate"
            type="action"
            [tooltip]="'order.marketplace.ready_to_ship.action_tooltip'"
            tooltipPosition="top"
            (emitOnClick)="onReadyToShipRow(rowData)"
          ></app-button>
        }
        @if (isReadyToShip(rowData)) {
          <app-button
            [testId]="'marketplace-order-action-print-waybill-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-edit"
            [label]="'order.marketplace.print_waybill.action' | translate"
            type="action"
            [tooltip]="'order.marketplace.print_waybill.action_tooltip'"
            tooltipPosition="top"
            (emitOnClick)="onPrintWaybillRow(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>

  <p-toast data-testid="marketplace-order-toast"></p-toast>

  <!-- Order Item Dialog -->
  <app-order-item-dialog
    data-testid="marketplace-order-item-dialog"
    [visible]="showOrderItemDialog()"
    [orderId]="selectedOrderId()"
    [orderNumber]="selectedOrderNumber()"
    (visibleChange)="onOrderItemDialogVisibleChange($event)"
  ></app-order-item-dialog>
</div>
